import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import Img from "gatsby-image/withIEPolyfill";

const Top = styled.div`
  display: flex;
`;
const Middle = styled.div`
  flex: 1;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Bottom = styled.div``;

const CloseContainer = styled.div`
  margin-right: 0.5rem;
  padding: 1.25rem;
  width: 4rem;
  height: 4rem;
  cursor: pointer;

  @media screen and (min-width: 600px) {
    margin-right: 1.5rem;
  }
`;

const Spacer = styled.div`
  flex: 1;
`;

const LogoContainer = styled.div`
  width: 6rem;
  transition: opacity 250ms ease-in-out;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 2rem;
  &:hover {
    opacity: 0.7;
  }
`;

const TopLogoContainer = styled.div`
  width: 16rem;
  height: 4rem;
  transition: opacity 250ms ease-in-out;
  margin-left: 1rem;
  &:hover {
    opacity: 0.7;
  }
  @media screen and (min-width: 600px) {
    margin-left: 2rem;
  }
`;

const NavLink = styled(Link)`
  display: inline-block;
  padding: 1rem;
  font-size: 1.25rem;
  text-decoration: none;

  &.active {
    //font-weight: bold;
    color: ${(props) => props.theme.bodySecondaryColor};
  }
`;

const LanguageBar = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-top: 5rem;
`;

const LanguageSelect = styled(Link)`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  color: ${(props) => (props.active ? "#bca273" : "#333")};
  text-decoration: none;
`;

const TTImageMobile = styled(Img)`
  width: 8rem;
`;

const MobileMenu = ({
  data: {
    crossImage,
    logo_image,
    logo_imageSharp,
    logo_2_image,
    logo_2_imageSharp,
    // nav_menu_image,
    nav_menu_imageSharp,
    pageContext,
    uri,
  },
  setOpen,
}) => {
  let { lang } = pageContext;
  if (!lang) {
    lang = "en-gb";
  }
  const linkPrefix = lang === "en-gb" ? "" : "/" + lang;
  const baseUri = uri
    .replace(/^\/trusttomorrow/, "")
    .replace(/^\/zh-hk/, "")
    .replace(/^\/zh-cn/, "");

  return (
    <>
      <Top>
        <TopLogoContainer>
          {logo_2_image && (
            <Link to={linkPrefix + "/"}>
              <Img
                style={{ height: "100%" }}
                fluid={logo_imageSharp.childImageSharp.fluid}
                fadeIn={false}
                objectFit={"contain"}
                alt={logo_image.alt}
              />
            </Link>
          )}
        </TopLogoContainer>
        <Spacer />
        <CloseContainer
          onClick={() => {
            setOpen(false);
          }}
        >
          <Img fluid={crossImage.childImageSharp.fluid} />
        </CloseContainer>
      </Top>
      <Middle>
        {/*<NavLink*/}
        {/*  activeClassName={"active"}*/}
        {/*  to={linkPrefix + "/chairman-message/"}*/}
        {/*>*/}
        {/*  {lang === "en-gb" ? "Chairman's Message" : ""}*/}
        {/*  {lang === "zh-hk" ? "董事長致辭" : ""}*/}
        {/*  {lang === "zh-cn" ? "董事长致辞" : ""}*/}
        {/*</NavLink>*/}
        {/*<NavLink activeClassName={"active"} to={linkPrefix + "/timeline/"}>*/}
        {/*  {lang === "en-gb" ? "Timeline" : ""}*/}
        {/*  {lang === "zh-hk" ? "情繫香港百五載" : ""}*/}
        {/*  {lang === "zh-cn" ? "情系香江百五载" : ""}*/}
        {/*</NavLink>*/}
        {/*<NavLink activeClassName={"active"} to={linkPrefix + "/our-stories/"}>*/}
        {/*  {lang === "en-gb" ? "Our Stories" : ""}*/}
        {/*  {lang === "zh-hk" ? "我們的故事" : ""}*/}
        {/*  {lang === "zh-cn" ? "我们的故事" : ""}*/}
        {/*</NavLink>*/}
        <NavLink
          activeClassName={"active"}
          to={linkPrefix + "/"}
          partiallyActive={true}
        >
          <TTImageMobile
            style={{ height: "100%" }}
            fluid={nav_menu_imageSharp.childImageSharp.fluid}
            objectFit={"contain"}
          />
        </NavLink>
        <LanguageBar>
          <LanguageSelect active={lang === "en-gb" ? 1 : 0} to={baseUri}>
            ENG
          </LanguageSelect>
          <LanguageSelect
            active={lang === "zh-hk" ? 1 : 0}
            to={"/zh-hk/" + baseUri}
          >
            繁
          </LanguageSelect>
          <LanguageSelect
            active={lang === "zh-cn" ? 1 : 0}
            to={"/zh-cn/" + baseUri}
          >
            简
          </LanguageSelect>
        </LanguageBar>
      </Middle>
      <Bottom>
        <LogoContainer>
          {logo_imageSharp && (
            <Link to={linkPrefix + "/"}>
              <Img
                style={{ height: "100%" }}
                fluid={logo_2_imageSharp.childImageSharp.fluid}
                fadeIn={false}
                objectFit={"contain"}
                alt={logo_2_image.alt}
              />
            </Link>
          )}
        </LogoContainer>
      </Bottom>
    </>
  );
};
export default MobileMenu;
